import type { GetAccountResponse } from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';
import type { EmptyObject } from '~/interfaces/common';

export const getAccount = sendRequest<EmptyObject, GetAccountResponse>({
  url: '/account',
  method: 'get',
});
